// What every Accelerator page of its own shares: the mastermind's rows for the member (useMastermind),
// and the product pages' own lines while they load or when they don't (ProductRoute.jsx's words).
import { useMember } from '../../app/member.jsx'
import { SITE } from '../../config/site.js'
import { useMastermind } from './useMastermind.js'
import { COPY } from './copy.js'
import '../../styles/accelerator.css'

// { freshLog: true }: the home and the log page (useMastermind.js)
export function useAccelerator(product, options) {
  const { me } = useMember()
  return useMastermind(product.id, me.person.id, options)
}

export function Loading({ className = '' }) {
  return <div className={`acc-loading ${className}`.trim()} aria-busy="true" />
}

export function LoadFailed({ onRetry }) {
  return (
    <section className="pp-failed">
      <h1 className="pp-failed-h1">{COPY.loadFailed}</h1>
      <p className="pp-failed-text">Check your connection and try again. If it keeps happening, email {SITE.helpEmail}.</p>
      <button type="button" className="pp-btn" onClick={onRetry}>{COPY.tryAgain}</button>
    </section>
  )
}
